import request from './request'
import storage from './storage'

const {
  REACT_APP_API_URL: API_URL,
  REACT_APP_CLIENT_HOST: CLIENT_HOST
} = process.env

const { characterSet, referrer = '', title } = document
const { innerHeight, innerWidth } = window
const { hostname } = window.location
const { availHeight, availWidth } = window.screen
const { language } = navigator
const dr = hostname === CLIENT_HOST ? '' : referrer

export const trackEvent = e =>
  request.post(`${API_URL}/analytics`, { cid: storage.getCID(), event: e })

export const trackPage = p =>
  request.post(`${API_URL}/analytics`, {
    dr,
    cid: storage.getCID(),
    de: characterSet,
    dt: title,
    pageview: p,
    sr: `${availHeight}x${availWidth}`,
    vp: `${innerHeight}x${innerWidth}`,
    ul: language
  })
